import type {
  DebugLogEntry,
  DebugPathlookupDevices,
} from '@ipfabric/utils/pathLookup/DebugPathlookup';
import {
  deviceViewPathlookupDebugEntityId,
  isPathlookupDebugEntity,
} from 'components/DeviceView/deviceViewTypes';
import type { DeviceViewCommandFactory } from '../DeviceViewModel';

export interface ShowPathlookupDebugCommand {
  entries: DebugLogEntry[];
  debugDevices: DebugPathlookupDevices;
}

export const showPathlookupDebug: DeviceViewCommandFactory<
  ShowPathlookupDebugCommand
> = (cmdContext) => (command) => {
  cmdContext.updateState((draft) => {
    if (
      !draft.deviceViewWindows.some(
        (win) => win.id === deviceViewPathlookupDebugEntityId,
      )
    ) {
      draft.deviceViewOpen = true;
    }

    draft.activeDeviceViewEntityId = deviceViewPathlookupDebugEntityId;

    const foundEntity = draft.deviceViewEntities.find(
      (entity) => entity.id === deviceViewPathlookupDebugEntityId,
    );

    if (foundEntity === undefined) {
      draft.deviceViewEntities.unshift({
        id: deviceViewPathlookupDebugEntityId,
        deviceViewElement: 'pathlookupDebug',
        entries: command.entries,
        debugDevices: command.debugDevices,
      });
      return;
    }

    if (isPathlookupDebugEntity(foundEntity)) {
      foundEntity.entries = command.entries;
      foundEntity.debugDevices = command.debugDevices;
    }
  });
};
